import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import Backend from 'i18next-http-backend'

import {DEFAULT_LANG} from '@/constants/lang'
import {getUserLanguage} from '@/services/lang'

const initI18nextPromise = i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: getUserLanguage(),
        fallbackLng: DEFAULT_LANG,
        debug: !_IS_PROD_ && !_IS_TEST_,
        ns: ['translation', 'enums', 'globals'],
        defaultNS: 'translation',
        returnObjects: true,
        backend: {
            queryStringParams: {v: _LAST_COMMIT_HASH_ || Date.now()}
        }
    })

export {i18next, initI18nextPromise}
export default i18next
